<template>
    <h3 class="tw-font-semibold lg:tw-text-xl">Section 1 - Purpose</h3>
    <p class="tw-text-base lg:tw-text-xl tw-font-normal">
        In compliance with the Republic Act No. 10173 known as
        Data Privacy Act of 2012,
        <i>“An Act Protecting Individual Personal Information in
            Information and Communications Systems in the Government and
            the Private Sector, creating for this Purpose a National
            Privacy Commission, and for Other Purposes,”
        </i>
        this data privacy policy has been designed by Ortigas and
        Company, Limited Partnership (OCC) to ensure protection of the
        right to privacy and communication of all partners and
        stakeholders while promoting easy access and flow of
        information.
    </p>
    <p class="tw-text-base lg:tw-text-xl tw-font-normal">
        This data privacy policy states OCC’s responsibilities for:
    </p>
    <p class="tw-text-base lg:tw-text-xl tw-font-normal">
        1. Compliance with data protection laws, regulations and best
        practices<br /><br />
        2. Protection for the rights of staff, partners and
        stakeholders<br /><br />
        3. Transparency about how personal data is stored and
        processed<br /><br />
        4. Prevention from the possibility of data breach
    </p>
    <p class="tw-text-base lg:tw-text-xl tw-font-normal">
        Furthermore, this data privacy policy shall guide the company
        and protect it against real data security risks such as breaches
        of confidentiality, reputational damage and failure to offer
        choices on personal data usage.
    </p>

    <h3 class="tw-font-semibold tw-text-2xl">
        Section 2 - Data Privacy Policy
    </h3>
    <p class="tw-text-base lg:tw-text-xl tw-font-normal">
        As part of our commitment to protect your privacy, OCC adheres
        to the following principles:
    </p>
    <p class="tw-text-base lg:tw-text-xl tw-font-normal">
        1. We shall comply with all applicable laws and regulations.<br /><br />
        2. We value the personal information given to us by our partners
        and we commit to use them in a way that is fair and worthy of
        their trust.
        <br /><br />
        3. We shall take all reasonable steps to keep confidentiality of
        information secure and prevent it from misuse.
        <br /><br />
        4. We shall be transparent in providing clear information about
        how we handle the information by clearly explaining the
        following:
    </p>
    <ul class="tw-text-base lg:tw-text-xl tw-space-y-8 alpha-list tw-font-normal">
        <li>
            <b>Policy Scope</b> <br /><br />
            This data privacy policy shall cover all personal
            information collected by OCC in connection with the
            products and services it offers. In this policy, “personal
            information” means information or pieces of information that
            may be used to identify an individual, including, but not
            limited to:
            <br /><br />
            <ul class="tw-text-base lg:tw-text-xl tw-space-y-8 roman-list tw-font-normal">
                <li>
                    Basic profile information such as name, date of
                    birth, gender, local/present/mailing address,
                    nationality and contact details.
                </li>
                <li>
                    Identity supporting documents such government issued
                    IDs and governments issued forms
                </li>
                <li>
                    Contact details which includes mobile/landline
                    number, home/office number, email address and
                    mailing address
                </li>
                <li>
                    Payment details which include credit card, bank
                    account number and other related information
                </li>
                <li>
                    Information about business, lifestyle or preferences
                    such as hobbies and interests
                </li>
            </ul>
            <br /><br />
            This policy shall also apply to the following:
            <br /><br />
            <ul class="tw-text-base lg:tw-text-xl tw-space-y-8 roman-list tw-font-normal">
                <li>
                    All branches of Ortigas & Company, Limited
                    Partnership
                </li>
                <li>
                    All regular and contractual employees of Ortigas &
                    Company, Limited Partnership
                </li>
                <li>
                    All customers of Ortigas & Company, Limited
                    Partnership
                </li>
                <li>
                    All contractors, suppliers and other people
                    contracted to represent or work on behalf of Ortigas
                    & Company, Limited Partnership
                </li>
                <li>Other stakeholders</li>
            </ul>
        </li>
        <li>
            <b>Why we need your information?</b> <br /><br />
            For the company to provide the best product and customer
            experience, collection and analysis of data becomes a
            relevant process. The collected data shall be used whenever
            applicable. Listed below are several operations where
            private information is considered as an essential component.
            <br /><br />
            <ul class="tw-text-base lg:tw-text-xl tw-space-y-8 roman-list tw-font-normal">
                <li>
                    Providing support efficiently to any individual with
                    issues, inquiries, requests and any other related
                    activities.
                </li>
                <li>
                    Managing of user account especially if there are
                    issues to be settled.
                </li>
                <li>Training of staff and other related personnel.</li>
                <li>
                    Distribution of promotional advertisements to
                    appropriate individual (e.g. rewards, surveys,
                    promos. etc.).
                </li>
                <li>
                    Sharing of individual’s data to third party
                    providers/services which the user permitted.
                </li>
                <li>
                    Analyzing marketing strategy which may enhance
                    product/service demand.
                </li>
                <li>
                    Accomplishing other tasks for processing or
                    disclosure that is mandatory under a government’s
                    law.
                </li>
            </ul>
        </li>
        <li>
            <b>What information is needed to be collected?</b>
            <br /><br />
            OCC shall only collect personal information that is
            necessary for one or more of its functions and activities in
            a manner that is lawful, fair and reasonably unobtrusive. We
            shall only collect directly from individuals. Whenever
            necessary to collect information from a third party, we
            shall ensure proper advise and consent from the concerned
            individual.
            <br /><br />
            When collecting personal information, we shall ensure that
            the individual is made aware of the identity of the OCC
            personnel who is collecting the data, the purpose of
            collecting the data, the individual’s right to data access,
            and the consequences of the failure to disclose or provide
            the information.
        </li>
        <li>
            <b>Where we receive this information?</b> <br /><br />
            Personal information may be collected from different
            sources, including:
            <br /><br />
            <ul class="tw-text-base lg:tw-text-xl tw-space-y-8 roman-list tw-font-normal">
                <li>
                    Information provided directly to us <br /><br />
                    <ul class="tw-text-base lg:tw-text-xl tw-space-y-8 policy-list tw-font-normal">
                        <li>
                            Purchase of our OCC’s products or services
                        </li>
                        <li>
                            Complaints, comments or inquiries lodged by
                            individuals directly to OCC
                        </li>
                        <li>Career application with the company</li>
                        <li>
                            Interaction with our sales or customer care
                            agents, reservation officers or specialists,
                            through e-mail, phone, chat services or
                            face-to-face meetings
                        </li>
                        <li>
                            Joining advertisement strategies like
                            promos, rewards & loyalty program, raffles
                            and others
                        </li>
                        <li>
                            When you submit your personal information to
                            us for any other reason
                        </li>
                    </ul>
                </li>
                <li>
                    Information collected when you connect to our
                    network or visit our sites<br /><br />
                    <ul class="tw-text-base lg:tw-text-xl tw-space-y-8 policy-list tw-font-normal">
                        <li>
                            Purchase of our OCC’s products or services
                        </li>
                        <li>
                            Use of our networks whether Wi-Fi, mobile or
                            other related channels
                        </li>
                        <li>
                            Accessing to our websites, applications and
                            other service channels.
                        </li>
                    </ul>
                </li>
                <li>
                    Information collected from other sources
                    <br /><br />
                    OCC may receive personal information from
                    legitimate sources, including commercially or
                    publicly sources such as public databases and
                    published directories and public documents. We may
                    also receive personal information from third parties
                    provided that there is a given consent from
                    concerned individual(s).
                </li>
            </ul>
            <br /><br />
            By providing OCC with your personal information in the use
            of any of our products and services as described in this
            policy, you have explicitly authorized and consented to our
            collection, use, access, transfer, storage and processing of
            said personal data.
        </li>
        <li>
            <b>Personal information other than yours</b> <br /><br />
            When you disclose to us another person’s personal
            information (i.e. your dependent, spouse, children and/or
            parents), you attest that consent has been obtained from
            that person to disclose and process personal information in
            accordance with this policy.
        </li>
        <li>
            <b>Who we share this information with?</b> <br /><br />
            OCC may share your personal information with the Ortigas
            Group of Companies and trusted third parties. We shall never
            share your information to other parties outside of our
            company unless there is a consent to provide your personal
            information or whenever required by law or legal process.
            <br /><br />
            OCC may share your personal information with companies,
            organizations, or individuals outside of the Ortigas Group
            of Companies if we deem it necessary to disclose information
            for legal reasons.
            <br /><br />
            Any company with which we share information about you for
            the above purposes is contractually required to comply with
            confidentiality standards, undertake to respect any
            individual’s right to privacy and comply with the Data
            Privacy Act. We also require that these organizations use
            this information only for our purposes and follow our
            reasonable directions with respect to this information. This
            includes organizations which handle or obtain personal
            information including service providers for OCC.
        </li>
        <li>
            <b>International data transfers</b> <br /><br />
            Information that we collect may be stored and processed in
            and transferred between any of the countries in which we
            make use of cloud services (i.e. Office 365, Amazon Web
            Services, and the like) in order to enable us to use the
            information in accordance with this policy.
            <br /><br />
            Personal information that you publish on our website or
            submit for publication on our website may be available, via
            the internet, around the world. We cannot prevent the use or
            misuse of such information by others.
        </li>
        <li>
            <b>How we secure your information?</b> <br /><br />
            OCC shall take all necessary precautions in securing your
            personal information. All trusted third parties handling or
            processing your information shall likewise be required to do
            the same. To protect these information from unauthorized
            access, alterations or misuse, OCC shall strictly implement
            the following security measures within the company:
            <br /><br />
            <ul class="tw-text-base lg:tw-text-xl tw-space-y-8 roman-list tw-font-normal">
                <li>
                    Access to personal information shall be restricted
                    to authorized users.
                </li>
                <li>
                    Personal information shall be protected using a
                    secured server behind a firewall, data encryption
                    and layered security controls.
                </li>
                <li>
                    Audit and testing of infrastructure equipment shall
                    be regularly performed to guarantee data security.
                </li>
            </ul>
        </li>
        <li>
            <b>Retention and disposal of your personal information</b>
            <br /><br />
            OCC will retain documents (including electronic documents)
            containing your personal data:
            <br /><br />
            <ul class="tw-text-base lg:tw-text-xl tw-space-y-8 roman-list tw-font-normal">
                <li>
                    To the extent that we are required to do so by law;
                </li>
                <li>
                    To the extent required by or pursuant to our
                    contracts;
                </li>
                <li>
                    If we believe that the documents may be relevant to
                    any ongoing or prospective legal proceedings in
                    order to establish, exercise or defend our legal
                    rights (including providing information to others
                    for the purposes of fraud prevention and reducing
                    credit risk).
                </li>
            </ul>
            <br /><br />
            Thereafter, your personal information shall be disposed or
            discarded in a secure manner that would prevent further
            processing, unauthorized access, or disclosure to any other
            party or the public.
        </li>
        <li>
            <b>We respect your rights as a data subject, which the DPA
                lists as follows:</b>
            <br /><br />
            <ul class="tw-text-base lg:tw-text-xl tw-space-y-8 roman-list tw-font-normal">
                <li>
                    You have the right to access information we hold
                    about you, subject to providing us with appropriate
                    evidence of your identity. We may withhold personal
                    data that you request to the extent permitted by
                    law.
                </li>
                <li>
                    You can object to us using your data for profiling
                    you or making automated decisions about you.
                </li>
                <li>
                    You have the right to port your data in a mutually
                    acceptable format.
                </li>
                <li>
                    You have the right for your data to be erased by
                    asking us to suspend, withdraw, remove, or destroy
                    your personal data, if it is no longer necessary for
                    us to hold the data for the stated purposes
                    (including for appropriate legal purposes).
                </li>
                <li>
                    You have the right to lodge a complaint regarding
                    our use of your data; but please tell us first, so
                    we have a chance to address your concerns. If we
                    fail in this, you can address any complaint to the
                    National Privacy Commission.
                </li>
                <li>
                    You have the right to damages arising from
                    inaccurate, incomplete, false, unlawfully obtained
                    or unauthorized use of your personal data
                </li>
            </ul>
        </li>
        <li>
            <b>How can you check and update your personal
                information?</b>
            <br /><br />
            OCC shall ensure that any concerned individual may update
            information securely to maintain data accuracy and
            relevance. Should there be a need to check or update your
            personal information, or if you wish to withdraw your given
            consent for any or all purposes set out in this Policy, you
            may get in touch with
            <br /><br />
            <i>Data Protection Officer<br />
                Ortigas Commercial Corporation<br />
                7F, West Wing, Estancia Offices, Capitol Commons,
                Meralco Avenue, Pasig City<br />
                Email:
                <a href="mailto:occ.dpo@ortigas.com.ph" class="text-decoration-none">occ.dpo@ortigas.com.ph</a>
            </i><br /><br />
            Depending on the nature of your consent withdrawal, OCC may
            no longer be in a position to continue to provide products
            and services to you.
        </li>
        <li>
            <b>Management and Security</b> <br /><br />
            A Data Privacy Officer has been designated for OCC and
            corresponding Compliance Officers of Privacy for our
            subsidiaries, if necessary, shall be appointed to manage and
            safeguard the handling of your personal information in
            compliance to the Philippine Data Privacy Act of 2012 or
            R.A. 10173 and this Policy. OCC Management is committed to
            ensure that its Privacy Management Program is constantly
            reviewed, monitored and enhanced. OCC regards personal
            information breaches very seriously.
        </li>
        <li>
            <b>Policy Updates</b> <br /><br />
            In compliance with the laws and regulations, OCC may change
            this policy as necessary. We shall provide notice of any
            material change, and shall obtain your consent if required
            by law.
        </li>
    </ul>
</template>
